import { Button, PageContainer } from "@shapr3d/frontend-lib";

import { getShaprURLProtocol } from "../../urlUtils";
import Heading from "../Heading/Heading";

import style from "./InstantTrialSuccess.module.css";

const InstantTrialSuccess = () => {
  return (
    <PageContainer>
      <div className={style.instantTrial}>
        <div className={style.instantTrialForm}>
          <Heading type="h1">Thank you!</Heading>
          <div className={style.text}>Your Shapr3D Pro 14-day free trial has been activated.</div>
          <Button
            onClick={() => {
              window.location.replace(`${getShaprURLProtocol()}://`);
            }}
          >
            Launch Shapr3D
          </Button>
        </div>
      </div>
    </PageContainer>
  );
};

export default InstantTrialSuccess;
